module.exports = __webpack_public_path__ + "media/images/ig-2c15bb68.svg";